module.exports = __webpack_public_path__ + "static/scale-model-of-western-heritage-center-in-billings-montana-47c4b8ecbad9711460335d1bd35a8031.png";